<template>
  <div class="okrs">
    <el-row justify="center">
      <el-col :span="17" align="center">
        <div class="okrs-call mt-5">
          <div v-html="data.call"></div>
        </div>
      </el-col>
    </el-row>

    <el-row justify="center" class="mt-5 mb-5">
      <el-col :span="20" align="center">
        <div class="education-call">
          <button
              class="btn-login btn-position"
              type="primary"
              round
            >
              <a href="https://bit.ly/3GOJnjQ" target="blank">Faça sua certificação em OKR aqui</a>
            </button>
        </div>
      </el-col>
    </el-row>

    <el-row justify="center" class="mb-5">
      <el-col :span="20" align="center" class="mb-5">
        <el-row class="vacation" justify="center" align="middle">
          <el-col align="right" :span="10">
            <div class="vacation-image">
              <figure>
                <img
                  class="icon"
                  alt="Vue logo"
                  src="../../assets/icons/vacation.png"
                />
              </figure>
            </div>
          </el-col>
          <el-col align="left" :span="14">
            <el-row justify="center" class="vacation-titles">
              <el-col align="left">
                <div v-html="data.list"></div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-row justify="center" align="center" class="mt-5 mb-5">
      <el-col :span="20" justify="center" align="center">
        <h3>OKRs #DREAMTEAM</h3>
      </el-col>
    </el-row>

    <el-row justify="center" align="center" class="mt-5 mb-5">
      <el-col :span="20" justify="center" align="center" class="okr-goal bg-green">
        <p>{{data.box1}}</p>
      </el-col>
      <el-col :span="20" align="center" class="okr-goal bg-lblue">
        <p>{{data.box2}}</p>
      </el-col>
      <el-col :span="20" align="center" class="okr-goal bg-purple">
        <p>{{data.box3}}</p>
      </el-col>
      <el-col :span="20" align="center" class="okr-goal bg-blue">
        <p>{{data.box4}}</p>
      </el-col>
    </el-row>

    <el-row justify="center" class="mt-5 mb-5  bot-space">
      <el-col :span="20" align="center">
        <div class="education-call">
          <button
              class="btn-login btn-position btn-change-color"
              type="primary"
              round
            >
              <a href="https://app.getbud.co/" target="blank">Clique aqui e acompanhe nossos Okrs</a>
            </button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { ref, onBeforeMount } from 'vue'
import { firebaseRoutes } from '../../config/firebase.conf'

export default {
  name: 'Okrs',
  setup () {
    const data = ref({})

    onBeforeMount(async () => {
      data.value = await axios.get(firebaseRoutes.okrs).then((response) => {
        const result = []
        for (const id in response.data) {
          result.push({
            id: id,
            call: response.data[id].call,
            list: response.data[id].list,
            box1: response.data[id].box1,
            box2: response.data[id].box2,
            box3: response.data[id].box3,
            box4: response.data[id].box4
          })
        }
        return result[0]
      })
    })

    return {
      data
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
@import "~@/styles/mixin.scss";

.vacation-titles {
  h4 {
    margin-bottom: 2rem;
  }
}

.vacation {
  padding-bottom: 3rem;
  background-color: $white;
}

.vacation-image {
  text-align: center;
  padding: 10rem 5rem 5rem 5rem;
  img {
    max-width: 180px;
  }
}

.btn-change-color {
  @include gradientBackgroundBlueStart;
}

.okr-goal {
  width: 100%;
  margin-top: 2rem;

  p {
    font-size: 2rem;
    color: $white;
    padding: 2rem;
  }
}
</style>
